import Layout from '../components/Layout';
import Contact from '../components/Contact';
import ProductsSection from '../components/ProductsSection';
import { PRODUCTS } from '../constants/app.js';

import Link from 'next/link';

import { Component } from 'react';

import API from '../utils/api';

const defaultState = {
  name: '',
  organization: '',
  email: '',
  industry: '',
  platform: 'linux64bit',
  product: Object.keys(PRODUCTS)[0],
  dialogOpen: false,
  errorDialogOpen: false,
};

export default class Products extends Component {
  constructor(props) {
    super(props);

    this.state = {...defaultState};

    this.onSubmit = this.onSubmit.bind(this);
  }

  async onSubmit(e) {
    e.preventDefault();

    try {
      await API.postRegister(this.state);

      this.setState({...defaultState, dialogOpen: true});
    } catch (err) {
      console.log(err);
    }
  }

  render() {
    return (
      <Layout>
        <div className="container">
          <h2 className="mb-30">Products</h2>

          <ProductsSection>
            <ul>
              {Object.keys(PRODUCTS).map((item, i) => (
                <li
                  key={i}
                  className="products-section__item"
                >
                  <h3>
                    <Link href={`/${item}`}>
                      <a className="products-section__link">{PRODUCTS[item].title}</a>
                    </Link>
                  </h3>
                  <div className="products-section__desc text-justify">
                    <p>
                      {PRODUCTS[item].description}
                    </p>
                  </div>
                </li>
              ))}
            </ul>
          </ProductsSection>
          <Contact/>
        </div>
      </Layout>
    );
  }
}